export default {
  totalLabel:
    'text-[#171b1A]! font-bold!  rounded-xs! overflow-hidden! text-end',
  totalAmount:
    'bg-[#0000000F]!  font-bold! text-[#171b1A]! px-3 rounded-xs py-2',
  addIcon: 'text-[#0070A2] cursor-pointer',
  deleteIcon: 'text-[#EF5350] cursor-pointer',
  tableBg: 'bg-[#BFDFD8]',
  emptyTable: 'w-full h-64 bg-[#BFDFD8]',
  tableRow: 'bg-[#BFDFD8]!',
  tableFooter:
    'text-base font-normal font-weight-700 leading-20.02 tracking-0.17 text-black',
  tableFooterRow: 'bg-[#BFDFD8]!',
  dollarIcon:
    'bg-[#026EA1] text-white text-4xl! p-[2px] rounded-md! cursor-pointer',
  errorRow: 'pt-0!',
  successColor:
    'bg-[#AC6E1A] text-white text-4xl! p-[2px] rounded-md! cursor-pointer',
};
